import React, { useState } from "react";
import HeroSection from '../components/sections/Hero.jsx';
import PageCTA from '../components/sections/pageCTA.jsx';

// ─── ICONS ────────────────────────────────────────────────────────────────────
const Icon = ({ d, size = 20, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth={1.8} strokeLinecap="round"
    strokeLinejoin="round" className={className}>
    <path d={d} />
  </svg>
);

const ICONS = {
  phone:    "M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.8 19.79 19.79 0 01.18 1.18 2 2 0 012 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z",
  mail:     "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z M22 6l-10 7L2 6",
  location: "M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z M12 10m-3 0a3 3 0 106 0 3 3 0 10-6 0",
  linkedin: "M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6z M2 9h4v12H2z M4 6m-2 0a2 2 0 104 0 2 2 0 10-4 0",
  twitter:  "M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z",
  instagram:"M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z",
  send:     "M22 2L11 13 M22 2L15 22 9 13 2 9z",
  user:     "M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2 M12 3m-4 0a4 4 0 108 0 4 4 0 10-8 0",
  building: "M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z M9 22V12h6v10",
  whatsapp: "M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z",
  arrow:    "M5 12h14 M12 5l7 7-7 7",
  check:    "M20 6L9 17l-5-5",
  globe:    "M2 12a10 10 0 1020 0 10 10 0 10-20 0 M2 12h20 M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z",
};

// ─── STYLES ───────────────────────────────────────────────────────────────────
const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;600;700;800&family=DM+Sans:ital,wght@0,300;0,400;0,500;1,300&display=swap');

  .nexus-title {
    background: linear-gradient(110deg, #fbbf24 35%, #a78bfa 50%, #fbbf24 65%);
    background-size: 200% 100%;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: shimmer 8s linear infinite;
  }
  @keyframes shimmer {
    0% { background-position: 0% 50%; }
    100% { background-position: 200% 50%; }
  }

  .contact-card {
    transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
  }
  .contact-card:hover { transform: translateY(-4px); }

  .nexus-input:focus {
    outline: none;
    border-color: rgb(217 119 6 / 0.8);
    box-shadow: 0 0 0 3px rgb(217 119 6 / 0.12);
  }

  /* Social hover — upgraded */
  .social-btn {
    transition: all 0.3s cubic-bezier(0.22,1,0.36,1);
    position: relative;
    overflow: hidden;
  }
  .social-btn::before {
    content: '';
    position: absolute;
    inset: 0;
    opacity: 0;
    transition: opacity 0.3s ease;
    border-radius: inherit;
  }
  .social-btn:hover { transform: translateY(-3px) scale(1.04); }
  .social-linkedin::before  { background: rgba(59,130,246,0.08); }
  .social-twitter::before   { background: rgba(14,165,233,0.08); }
  .social-instagram::before { background: rgba(236,72,153,0.08); }
  .social-globe::before     { background: rgba(251,191,36,0.08); }
  .social-btn:hover::before { opacity: 1; }

  .submit-btn {
    position: relative; overflow: hidden;
    transition: all 0.3s ease;
  }
  .submit-btn::after {
    content: '';
    position: absolute; inset: 0;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.12), transparent);
    transform: translateX(-100%);
    transition: transform 0.5s ease;
  }
  .submit-btn:hover::after { transform: translateX(100%); }
  .submit-btn:hover { transform: translateY(-2px); box-shadow: 0 8px 24px rgba(217,119,6,0.35); }

  .dot-grid {
    background-image: radial-gradient(circle, rgba(251,191,36,0.12) 1px, transparent 1px);
    background-size: 28px 28px;
  }

  @keyframes fadeUp {
    from { opacity: 0; transform: translateY(20px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  .fade-up   { animation: fadeUp 0.7s ease forwards; }
  .fade-up-1 { animation-delay: 0.1s; opacity: 0; }
  .fade-up-2 { animation-delay: 0.2s; opacity: 0; }
  .fade-up-3 { animation-delay: 0.3s; opacity: 0; }
  .fade-up-4 { animation-delay: 0.4s; opacity: 0; }

  .map-glow {
    box-shadow: 0 0 0 1px rgba(167,139,250,0.25), 0 16px 48px rgba(109,40,217,0.2);
  }

  .divider {
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(251,191,36,0.3), transparent);
  }

  /* Card accent animations */
  @keyframes nx-ring-pulse {
    0%, 100% { transform: scale(1);   opacity: 0.6; }
    50%       { transform: scale(1.2); opacity: 1;   }
  }
  @keyframes nx-flow {
    0%   { stroke-dashoffset: 20; }
    100% { stroke-dashoffset: 0; }
  }
  @keyframes nx-bounce {
    0%, 100% { transform: translateY(0); }
    50%       { transform: translateY(-4px); }
  }
  @keyframes nx-radar {
    from { transform: rotate(0deg); }
    to   { transform: rotate(360deg); }
  }
  @keyframes nx-node-pulse {
    0%, 100% { opacity: 0.6; transform: scale(1); }
    50%       { opacity: 1;   transform: scale(1.2); }
  }
  .nx-node { animation: nx-node-pulse 2s ease-in-out infinite; }
  .nx-bounce { animation: nx-bounce 2.5s ease-in-out infinite; }

  /* Signal flow infographic */
  @keyframes nx-signal-travel {
    0%   { stroke-dashoffset: 120; opacity: 0; }
    20%  { opacity: 1; }
    100% { stroke-dashoffset: 0;   opacity: 1; }
  }
  @keyframes nx-step-glow {
    0%, 100% { box-shadow: 0 0 0px rgba(251,191,36,0);    }
    50%       { box-shadow: 0 0 20px rgba(251,191,36,0.2); }
  }
  .nx-step-active { animation: nx-step-glow 2.4s ease-in-out infinite; }

  @keyframes nx-signal-line {
    0%   { stroke-dashoffset: 100; }
    100% { stroke-dashoffset: 0; }
  }
  .nx-signal-line {
    stroke-dasharray: 6 3;
    animation: nx-signal-line 1.8s linear infinite;
  }

  /* CTA mesh */
  .nexus-cta-bg {
    background-image:
      radial-gradient(at 20% 50%, rgba(251,191,36,0.08) 0px, transparent 50%),
      radial-gradient(at 80% 50%, rgba(139,92,246,0.08) 0px, transparent 50%),
      radial-gradient(at 50% 80%, rgba(6,182,212,0.05) 0px, transparent 50%);
  }
  .nexus-grid-lines {
    background-image:
      linear-gradient(rgba(251,191,36,0.03) 1px, transparent 1px),
      linear-gradient(90deg, rgba(251,191,36,0.03) 1px, transparent 1px);
    background-size: 40px 40px;
  }
`;

// ─── CONTACT DETAILS ──────────────────────────────────────────────────────────
const CONTACT_INFO = [
  {
    icon: "phone",
    label: "Call Us",
    value: "+91 92353 27048",
    sub: "Mon–Sat, 9 AM – 7 PM IST",
    href: "tel:+919235327048",
    accentType: "phone",
  },
  {
    icon: "whatsapp",
    label: "WhatsApp",
    value: "Message Instantly",
    sub: "Quick responses guaranteed",
    href: "https://wa.me/919235327048?text=Hello%20Hekaos%20Team,%20I%20would%20like%20to%20connect.",
    accentType: "whatsapp",
  },
  {
    icon: "mail",
    label: "Email",
    value: "hekaosIT@gmail.com",
    sub: "No SLA — just real replies",
    href: "mailto:hekaosIT@gmail.com",
    accentType: "email",
  },
  {
    icon: "location",
    label: "Office",
    value: "India",
    sub: "India — 226 010",
    href: "https://maps.app.goo.gl/XkM9JFPF4DeMtoSf8",
    accentType: "location",
  },
];

const SOCIALS = [
  { icon: "linkedin",  label: "LinkedIn",  href: "https://linkedin.com/company/hekaos",  colorClass: "social-linkedin",  hoverText: "hover:text-blue-400", hoverBorder: "hover:border-blue-500/40" },
  { icon: "twitter",   label: "Twitter/X", href: "https://twitter.com/hekaosinc",        colorClass: "social-twitter",   hoverText: "hover:text-sky-400",  hoverBorder: "hover:border-sky-500/40"  },
  { icon: "instagram", label: "Instagram", href: "https://instagram.com/hekaos",         colorClass: "social-instagram", hoverText: "hover:text-pink-400", hoverBorder: "hover:border-pink-500/40" },
  { icon: "globe",     label: "Website",   href: "https://hekaos.com",                   colorClass: "social-globe",     hoverText: "hover:text-amber-400",hoverBorder: "hover:border-amber-500/40"},
];

const INQUIRY_TYPES = [
  "AI Strategy & Consulting",
  "Platform Integration",
  "Partnership / Collaboration",
  "Career Opportunities",
  "Product Demo",
  "Other",
];

// ─── CARD ACCENTS ─────────────────────────────────────────────────────────────

// Phone — sound wave rings emanating outward
const PhoneAccent = () => (
  <svg width="52" height="40" viewBox="0 0 52 40" fill="none">
    {[0,1,2].map(i => (
      <path key={i}
        d={`M${26 - 6 - i*6},${20 + 6 + i*5} Q${26},${20 - 8 - i*7} ${26 + 6 + i*6},${20 + 6 + i*5}`}
        stroke={`rgba(251,191,36,${0.6 - i*0.15})`}
        strokeWidth={2 - i*0.4}
        fill="none"
        strokeLinecap="round"
        style={{ animation: `nx-ring-pulse 2s ease-in-out ${i*0.3}s infinite` }}
      />
    ))}
    <circle cx="26" cy="20" r="3.5" fill="rgba(251,191,36,0.9)" className="nx-node" />
  </svg>
);

// WhatsApp — message bubble with signal dots
const WhatsAppAccent = () => (
  <svg width="52" height="40" viewBox="0 0 52 40" fill="none">
    <rect x="8" y="8" width="30" height="20" rx="8" fill="rgba(34,197,94,0.08)" stroke="rgba(34,197,94,0.4)" strokeWidth="1.5" />
    <rect x="8" y="24" width="10" height="8" rx="2" fill="rgba(34,197,94,0.08)" stroke="none" />
    <polygon points="8,28 18,24 18,32" fill="rgba(34,197,94,0.4)" />
    {[0,1,2].map(i => (
      <circle key={i} cx={16 + i*7} cy="18" r="2.5"
        fill={`rgba(34,197,94,${0.5 + i*0.15})`}
        style={{ animation: `nx-node-pulse 1.6s ease-in-out ${i*0.2}s infinite` }}
      />
    ))}
  </svg>
);

// Email — envelope with signal lines flying out
const EmailAccent = () => (
  <svg width="52" height="40" viewBox="0 0 52 40" fill="none">
    <rect x="6" y="12" width="28" height="20" rx="3" stroke="rgba(167,139,250,0.45)" strokeWidth="1.5" fill="rgba(167,139,250,0.05)" />
    <polyline points="6,12 20,22 34,12" stroke="rgba(167,139,250,0.6)" strokeWidth="1.5" strokeLinejoin="round" fill="none" />
    {[0,1,2].map(i => (
      <line key={i}
        x1="38" y1={14 + i*6} x2={44 + i*2} y2={14 + i*6}
        stroke={`rgba(167,139,250,${0.35 + i*0.15})`}
        strokeWidth="1.5" strokeLinecap="round"
        className="nx-signal-line"
        style={{ animationDelay: `${i*0.2}s` }}
      />
    ))}
  </svg>
);

// Location — radar-style ping
const LocationAccent = () => (
  <svg width="52" height="40" viewBox="0 0 52 40" fill="none">
    <circle cx="26" cy="20" r="14" stroke="rgba(167,139,250,0.15)" strokeWidth="1" strokeDasharray="3 3" />
    <circle cx="26" cy="20" r="9"  stroke="rgba(167,139,250,0.28)" strokeWidth="1" strokeDasharray="3 3" />
    <circle cx="26" cy="20" r="4"  stroke="rgba(167,139,250,0.5)"  strokeWidth="1.5" />
    <g style={{ transformOrigin: "26px 20px", animation: "nx-radar 3s linear infinite" }}>
      <line x1="26" y1="20" x2="26" y2="6" stroke="rgba(167,139,250,0.7)" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M26,20 L38,10 A14,14 0 0,0 26,6 Z" fill="rgba(167,139,250,0.06)" />
    </g>
    <circle cx="26" cy="20" r="2" fill="rgba(167,139,250,0.9)" />
  </svg>
);

const CARD_ACCENTS = {
  phone:    { accent: <PhoneAccent />,    border: "border-amber-800/30", hoverBorder: "hover:border-amber-500/50",  iconBg: "bg-amber-900/30",  iconColor: "text-amber-400",  valueColor: "text-amber-300",  glow: "rgba(251,191,36,0.06)"  },
  whatsapp: { accent: <WhatsAppAccent />, border: "border-green-800/30", hoverBorder: "hover:border-green-500/50",  iconBg: "bg-green-900/30",  iconColor: "text-green-400",  valueColor: "text-green-300",  glow: "rgba(34,197,94,0.06)"   },
  email:    { accent: <EmailAccent />,    border: "border-violet-800/30",hoverBorder: "hover:border-violet-500/50", iconBg: "bg-violet-900/30", iconColor: "text-violet-400", valueColor: "text-violet-300", glow: "rgba(139,92,246,0.06)"  },
  location: { accent: <LocationAccent />, border: "border-violet-800/30",hoverBorder: "hover:border-violet-500/50", iconBg: "bg-violet-900/30", iconColor: "text-violet-400", valueColor: "text-violet-300", glow: "rgba(139,92,246,0.06)"  },
};

// ─── CONNECTION SIGNAL INFOGRAPHIC ────────────────────────────────────────────
const ConnectionSignal = () => {
  const steps = [
    {
      number: "01",
      label: "Message Received",
      desc: "Your inquiry lands in our intelligence queue — routed by intent, not inbox.",
      color: "rgba(251,191,36,1)",
      bg:    "rgba(251,191,36,0.07)",
      border:"rgba(251,191,36,0.25)",
    },
    {
      number: "02",
      label: "Intent Classified",
      desc: "We identify what you need — strategy, integration, partnership, or product — and route to the right person.",
      color: "rgba(167,139,250,1)",
      bg:    "rgba(167,139,250,0.07)",
      border:"rgba(167,139,250,0.25)",
    },
    {
      number: "03",
      label: "Response Dispatched",
      desc: "No automated replies. When we respond, it means something.",
      color: "rgba(6,182,212,1)",
      bg:    "rgba(6,182,212,0.07)",
      border:"rgba(6,182,212,0.25)",
    },
  ];

  return (
    <section className="mb-20 fade-up fade-up-3">
      <div className="text-center mb-10">
        <p className="text-xs font-semibold tracking-widest uppercase text-slate-500 mb-2">
          How It Works
        </p>
        <h2 className="text-2xl font-semibold text-slate-100 tracking-tight mb-3">
          The Connection Signal
        </h2>
        <p className="text-slate-400 max-w-xl mx-auto text-sm leading-relaxed">
          Every message you send enters a structured response loop — no black boxes, no dead ends.
        </p>
      </div>

      {/* Desktop */}
      <div className="hidden md:flex items-center justify-center gap-0 max-w-4xl mx-auto">
        {steps.map((step, i) => (
          <React.Fragment key={i}>
            {/* Step card */}
            <div className="nx-step-active flex flex-col items-center text-center w-64 px-4"
              style={{ animationDelay: `${i*0.4}s` }}>
              <div className="w-16 h-16 rounded-2xl flex items-center justify-center mb-4 relative"
                style={{ background: step.bg, border: `1px solid ${step.border}` }}>
                <span className="text-lg font-bold font-mono" style={{ color: step.color }}>{step.number}</span>
                {/* Glow dot */}
                <div className="absolute -top-1 -right-1 w-3 h-3 rounded-full nx-node"
                  style={{ background: step.color, boxShadow: `0 0 8px ${step.color}` }} />
              </div>
              <p className="font-bold text-sm tracking-tight mb-2" style={{ color: step.color }}>{step.label}</p>
              <p className="text-slate-500 text-xs leading-relaxed">{step.desc}</p>
            </div>

            {/* Connector arrow */}
            {i < steps.length - 1 && (
              <div className="flex flex-col items-center pb-16 w-16 flex-shrink-0">
                <svg width="64" height="20" viewBox="0 0 64 20" fill="none">
                  <line x1="0" y1="10" x2="52" y2="10"
                    stroke={steps[i].color} strokeWidth="1.5"
                    className="nx-signal-line"
                    style={{ animationDelay: `${i*0.3}s` }}
                  />
                  <polyline points="44,4 56,10 44,16"
                    stroke={steps[i+1].color} strokeWidth="1.5"
                    fill="none" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
            )}
          </React.Fragment>
        ))}
      </div>

      {/* Mobile */}
      <div className="md:hidden flex flex-col items-center gap-0 max-w-sm mx-auto">
        {steps.map((step, i) => (
          <React.Fragment key={i}>
            <div className="nx-step-active flex items-start gap-4 w-full rounded-xl px-5 py-4"
              style={{ background: step.bg, border: `1px solid ${step.border}`, animationDelay: `${i*0.4}s` }}>
              <div className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0"
                style={{ background: "rgba(0,0,0,0.2)", border: `1px solid ${step.border}` }}>
                <span className="text-sm font-bold font-mono" style={{ color: step.color }}>{step.number}</span>
              </div>
              <div>
                <p className="font-bold text-sm mb-1" style={{ color: step.color }}>{step.label}</p>
                <p className="text-slate-500 text-xs leading-relaxed">{step.desc}</p>
              </div>
            </div>
            {i < steps.length - 1 && (
              <div className="flex flex-col items-center py-2">
                <svg width="20" height="32" viewBox="0 0 20 32" fill="none">
                  <line x1="10" y1="0" x2="10" y2="22"
                    stroke="rgba(167,139,250,0.4)" strokeWidth="1.5"
                    className="nx-signal-line" />
                  <polyline points="4,16 10,26 16,16"
                    stroke="rgba(167,139,250,0.5)" strokeWidth="1.5"
                    fill="none" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </section>
  );
};

// ─── MAIN COMPONENT ───────────────────────────────────────────────────────────
const ConnectPage = ({ setCurrentPage = () => {} }) => {
  const [form, setForm] = useState({ name: "", email: "", company: "", inquiry: "", message: "" });
  const [submitted, setSubmitted] = useState(false);
  const [focused, setFocused] = useState(null);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  const handleSubmit = (e) => {
    e.preventDefault();
    const msg = encodeURIComponent(
      `Hello Hekaos Team,\n\nName: ${form.name}\nEmail: ${form.email}\nCompany: ${form.company}\nInquiry: ${form.inquiry}\n\nMessage:\n${form.message}`
    );
    window.open(`https://wa.me/919235327048?text=${msg}`, "_blank");
    setSubmitted(true);
  };

  return (
    <>
      <style>{styles}</style>
      <div className="connect-root space-y-20 max-w-6xl mx-auto px-4 pb-20">

        {/* ── HERO ─────────────────────────────────────────── */}
        <section className="relative pt-16 pb-10 text-center fade-up fade-up-1">
          <div className="dot-grid absolute inset-0 rounded-2xl -z-10 opacity-60" />
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-amber-600/30 bg-amber-900/10 mb-6">
            <span className="w-2 h-2 rounded-full bg-amber-400 animate-pulse" />
            <span className="text-amber-400 text-xs font-semibold tracking-widest uppercase">Connect with Intelligence</span>
          </div>
          <h1 className="text-5xl md:text-6xl font-extrabold leading-tight mb-5">
            <span className="nexus-title">Hekaos Nexus</span>
          </h1>
          <p className="text-slate-400 max-w-xl mx-auto text-lg leading-relaxed">
            Where minds, systems, and intent converge — turning conversation into alignment, and alignment into execution.
          </p>
        </section>

        {/* ── CONTACT CARDS ────────────────────────────────── */}
        <section className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 fade-up fade-up-2">
          {CONTACT_INFO.map((item) => {
            const cfg = CARD_ACCENTS[item.accentType];
            return (
              <a key={item.label}
                href={item.href}
                target={item.href.startsWith("http") ? "_blank" : undefined}
                rel="noreferrer"
                className={`contact-card block rounded-xl p-5 bg-slate-900 border ${cfg.border} ${cfg.hoverBorder} group no-underline overflow-hidden relative`}>

                {/* Glow background */}
                <div className="absolute inset-0 pointer-events-none rounded-xl"
                  style={{ background: `radial-gradient(ellipse at 80% 20%, ${cfg.glow} 0%, transparent 60%)` }} />

                {/* Icon + Accent row */}
                <div className="relative flex items-center justify-between mb-4">
                  <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${cfg.iconBg} ${cfg.iconColor}`}>
                    <Icon d={ICONS[item.icon]} size={18} />
                  </div>
                  <div className="nx-bounce" style={{ animationDelay: `${Math.random()*0.5}s` }}>
                    {cfg.accent}
                  </div>
                </div>

                <p className="text-slate-500 text-xs font-semibold tracking-wider uppercase mb-1 relative">{item.label}</p>
                <p className={`font-semibold text-sm mb-1 ${cfg.valueColor} group-hover:brightness-125 transition-all relative`}>
                  {item.value}
                </p>
                <p className="text-slate-500 text-xs relative">{item.sub}</p>
              </a>
            );
          })}
        </section>

        <div className="divider" />

        {/* ── CONNECTION SIGNAL INFOGRAPHIC ────────────────── */}
        <ConnectionSignal />

        <div className="divider" />

        {/* ── FORM + MAP ───────────────────────────────────── */}
        <section className="grid grid-cols-1 lg:grid-cols-2 gap-10 fade-up fade-up-3">

          {/* FORM */}
          <div>
            <div className="mb-8">
              <p className="text-xs font-semibold tracking-widest uppercase text-slate-500 mb-2">Get In Touch</p>
              <h2 className="text-3xl font-bold text-slate-100 mb-2">Start a Conversation</h2>
              <p className="text-slate-500 text-sm">Tell us what you're building. We'll tell you how intelligence can help.</p>
            </div>

            {submitted ? (
              <div className="rounded-xl border border-amber-600/30 bg-amber-900/10 p-10 text-center">
                <div className="w-14 h-14 rounded-full bg-amber-600/20 flex items-center justify-center mx-auto mb-4">
                  <Icon d={ICONS.check} size={28} className="text-amber-400" />
                </div>
                <h3 className="text-xl font-bold text-amber-300 mb-2">Message Sent!</h3>
                <p className="text-slate-400 text-sm">Opening WhatsApp — we'll respond shortly.</p>
                <button
                  onClick={() => setSubmitted(false)}
                  className="mt-6 text-xs text-slate-500 hover:text-slate-300 transition-colors"
                >
                  Send another →
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {[
                    { name: "name",  placeholder: "Your name",    icon: "user" },
                    { name: "email", placeholder: "Email address", icon: "mail" },
                  ].map((f) => (
                    <div key={f.name} className="relative">
                      <span className={`absolute left-3 top-1/2 -translate-y-1/2 transition-colors ${focused === f.name ? "text-amber-400" : "text-slate-600"}`}>
                        <Icon d={ICONS[f.icon]} size={15} />
                      </span>
                      <input
                        name={f.name} value={form[f.name]} onChange={handleChange}
                        onFocus={() => setFocused(f.name)} onBlur={() => setFocused(null)}
                        placeholder={f.placeholder} required
                        className="nexus-input w-full bg-slate-900 border border-slate-700/60 rounded-lg pl-9 pr-4 py-3 text-sm text-slate-200 placeholder-slate-600 transition-all"
                      />
                    </div>
                  ))}
                </div>

                <div className="relative">
                  <span className={`absolute left-3 top-1/2 -translate-y-1/2 transition-colors ${focused === "company" ? "text-amber-400" : "text-slate-600"}`}>
                    <Icon d={ICONS.building} size={15} />
                  </span>
                  <input
                    name="company" value={form.company} onChange={handleChange}
                    onFocus={() => setFocused("company")} onBlur={() => setFocused(null)}
                    placeholder="Company / Organization (optional)"
                    className="nexus-input w-full bg-slate-900 border border-slate-700/60 rounded-lg pl-9 pr-4 py-3 text-sm text-slate-200 placeholder-slate-600 transition-all"
                  />
                </div>

                <div className="relative">
                  <select
                    name="inquiry" value={form.inquiry} onChange={handleChange}
                    onFocus={() => setFocused("inquiry")} onBlur={() => setFocused(null)}
                    required
                    className="nexus-input w-full bg-slate-900 border border-slate-700/60 rounded-lg px-4 py-3 text-sm text-slate-200 appearance-none transition-all cursor-pointer"
                  >
                    <option value="" disabled className="text-slate-600">Select inquiry type</option>
                    {INQUIRY_TYPES.map((t) => (
                      <option key={t} value={t} className="bg-slate-900">{t}</option>
                    ))}
                  </select>
                  <span className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-600 pointer-events-none">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M6 9l6 6 6-6" />
                    </svg>
                  </span>
                </div>

                <textarea
                  name="message" value={form.message} onChange={handleChange}
                  onFocus={() => setFocused("message")} onBlur={() => setFocused(null)}
                  placeholder="Tell us what you're building or exploring..."
                  rows={5} required
                  className="nexus-input w-full bg-slate-900 border border-slate-700/60 rounded-lg px-4 py-3 text-sm text-slate-200 placeholder-slate-600 resize-none transition-all"
                />

                <button type="submit"
                  className="submit-btn w-full bg-amber-600 hover:bg-amber-500 text-black font-bold py-3.5 rounded-lg text-sm flex items-center justify-center gap-2">
                  <Icon d={ICONS.send} size={16} />
                  Send via WhatsApp
                </button>
                <p className="text-center text-slate-600 text-xs mt-1">
                  Opens WhatsApp · Your message is pre-filled
                </p>
              </form>
            )}
          </div>

          {/* MAP + ADDRESS */}
          <div className="space-y-5">
            <div className="mb-8">
              <p className="text-xs font-semibold tracking-widest uppercase text-slate-500 mb-2">Location</p>
              <h2 className="text-3xl font-bold text-slate-100 mb-2">Find Us</h2>
              <p className="text-slate-500 text-sm">Headquartered in India — operating globally.</p>
            </div>

            <div className="rounded-xl overflow-hidden map-glow border border-violet-800/30" style={{ height: 260 }}>
              <iframe
                title="HEKAOS Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3501.1509019148143!2d77.4370754!3d28.6552!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38b65f00a18ceb%3A0xd0b9843922485fa3!2sHekaos!5e0!3m2!1sen!2sin!4v1771965741397!5m2!1sen!2sin"
                width="100%" height="100%"
                style={{ border: 0, filter: "invert(90%) hue-rotate(180deg) saturate(0.6)" }}
                allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"
              />
            </div>

            <div className="rounded-xl bg-slate-900 border border-slate-700/50 p-5 flex items-start gap-4">
              <div className="w-9 h-9 rounded-lg bg-violet-900/30 text-violet-400 flex items-center justify-center flex-shrink-0 mt-0.5">
                <Icon d={ICONS.location} size={16} />
              </div>
              <div>
                <p className="text-slate-100 font-semibold text-sm mb-0.5">HEKAOS Intelligence</p>
                <p className="text-slate-400 text-sm leading-relaxed">India</p>
                <a href="https://maps.app.goo.gl/XkM9JFPF4DeMtoSf8" target="_blank" rel="noreferrer"
                  className="inline-flex items-center gap-1.5 mt-3 text-xs text-violet-400 hover:text-violet-300 transition-colors font-medium">
                  Open in Google Maps
                  <Icon d={ICONS.arrow} size={12} />
                </a>
              </div>
            </div>

            <div className="rounded-xl bg-slate-900 border border-slate-700/50 p-5">
              <p className="text-xs font-semibold tracking-wider text-slate-500 uppercase mb-3">Office Hours</p>
              <div className="space-y-2">
                {[
                  ["Monday – Friday", "9:00 AM – 7:00 PM IST", true],
                  ["Saturday",        "10:00 AM – 4:00 PM IST", true],
                  ["Sunday",          "Closed", false],
                ].map(([day, time, open]) => (
                  <div key={day} className="flex justify-between items-center">
                    <span className="text-slate-400 text-sm">{day}</span>
                    <span className={`text-sm font-medium ${open ? "text-amber-400" : "text-slate-600"}`}>{time}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <div className="divider" />

        {/* ── SOCIAL ───────────────────────────────────────── */}
        <section className="fade-up fade-up-4 text-center">
          <p className="text-xs font-semibold tracking-widest uppercase text-slate-500 mb-2">Follow & Connect</p>
          <p className="text-slate-400 text-sm mb-8 max-w-md mx-auto">
            Stay close to what we're building — products, research, and intelligence engineering updates.
          </p>
          <div className="flex items-center justify-center gap-4 flex-wrap">
            {SOCIALS.map((s) => (
              <a key={s.label} href={s.href} target="_blank" rel="noreferrer"
                className={`social-btn ${s.colorClass} flex items-center gap-2.5 px-5 py-2.5 rounded-full bg-slate-900 border border-slate-700/50 text-slate-400 text-sm font-medium no-underline ${s.hoverText} ${s.hoverBorder} transition-colors`}>
                <Icon d={ICONS[s.icon]} size={15} />
                {s.label}
              </a>
            ))}
          </div>
        </section>

        {/* ── CTA ──────────────────────────────────────────── */}
        <PageCTA page="Connect" setCurrentPage={setCurrentPage} />

      </div>
    </>
  );
};

export default ConnectPage;